import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";

const HomeSection: FCX = ({
    children,
    style,
    className,
    testId,
    id
}) => {
    return (
        <div
            className={cn('HomeSection', className)}
            style={style}
            id={id}
            data-testid={testId}
        >
            {children}
        </div>
    );
}

export default HomeSection;